"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jotai_1 = require("jotai");
var react_1 = __importStar(require("react"));
var selected_variant_state_1 = require("../../misc/selected-variant-state");
var action_sheet_1 = __importDefault(require("../../plugins/action-sheet"));
var default_usage_1 = __importDefault(require("../oos-signup/default-usage"));
var app_1 = __importDefault(require("../pdp-add-to-cart/app"));
var product_with_details_1 = __importDefault(require("./product-with-details"));
var state_1 = require("./state");
var use_window_dimensions_1 = require("./use-window-dimensions");
var ProductSheet = function (_a) {
    var onDoneAddingToCart = _a.onDoneAddingToCart, hideLearnMoreLink = _a.hideLearnMoreLink;
    var _b = __read((0, react_1.useState)(0), 2), fixedBottomChildHeight = _b[0], setFixedBottomChildHeight = _b[1];
    var _c = __read((0, jotai_1.useAtom)(state_1.modalOpenAtom), 2), modalOpen = _c[0], setModalOpen = _c[1];
    var product = (0, jotai_1.useAtomValue)(state_1.productAtom);
    var productUrl = (0, jotai_1.useAtomValue)(state_1.productUrlAtom);
    var mainImageCover = (0, jotai_1.useAtomValue)(state_1.mainImageCoverAtom);
    var bottomImageUrl = (0, jotai_1.useAtomValue)(state_1.bottomImageUrlAtom);
    var width = (0, use_window_dimensions_1.useWindowDimensions)().width;
    var renderFixedBottomChild = !(width !== null && width >= window.breakpoints.medium);
    var selectedVariant = (0, selected_variant_state_1.useSelectedVariantStore)(function (state) { return state.variant; });
    // TODO: Maybe accept this as a prop. Here is a starting point: https://github.com/launched-la/hb-theme/pull/342/commits/2b3814be6dff88499d6983c2b51f95255a19fe65
    var fixedBottomChild = (0, react_1.useMemo)(function () {
        if (!product)
            return null;
        if (!selectedVariant)
            return null;
        return (react_1.default.createElement("div", { className: 'width-100 bg-white' },
            react_1.default.createElement("div", { className: 'padding-horizontal-3 padding-top-3' },
                react_1.default.createElement(app_1.default, { nonShoppableSiteSettings: { enabled: false }, hidePrice: true, enableOutOfStockLogic: true, onDoneAddingToCart: function (variant) {
                        setModalOpen(false);
                        if (onDoneAddingToCart)
                            onDoneAddingToCart(product, variant);
                    } })),
            (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.available) ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'padding-top-3' }))) : (react_1.default.createElement(default_usage_1.default, { variant: selectedVariant }))));
    }, [setModalOpen, selectedVariant, onDoneAddingToCart, product]);
    // we'd normally use a normal ref with a layout effect for this, but refs are null in react-modal children (https://stackoverflow.com/a/72392048)
    var fixedBottomChildContainerCallback = (0, react_1.useCallback)(function (ref) {
        var height = (function () {
            if (!renderFixedBottomChild)
                return 0;
            if (!fixedBottomChild)
                return 0;
            if (ref === null)
                return 0;
            return ref.clientHeight;
        })();
        setFixedBottomChildHeight(height);
    }, [fixedBottomChild, renderFixedBottomChild]);
    return (react_1.default.createElement(action_sheet_1.default, { handleClose: function () { return setModalOpen(false); }, isOpen: modalOpen }, product && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { marginBottom: fixedBottomChildHeight + 20 } },
            react_1.default.createElement(product_with_details_1.default, { className: 'quick-add-modal', product: product, productUrl: productUrl, mainImageCover: mainImageCover, bottomImageUrl: bottomImageUrl, onDoneAddingToCart: function (variant) {
                    setModalOpen(false);
                    if (onDoneAddingToCart)
                        onDoneAddingToCart(product, variant);
                }, hideLearnMoreLink: hideLearnMoreLink })),
        fixedBottomChild && renderFixedBottomChild && (react_1.default.createElement("div", { ref: fixedBottomChildContainerCallback, className: 'border-seashell bordered', style: {
                position: 'fixed',
                bottom: 0,
                width: '100%',
                boxShadow: '1px 0px 7px rgba(0,0,0,0.1)',
            } }, fixedBottomChild))))));
};
exports.default = ProductSheet;
